<button [disabled]="disabled" (click)="navigate()"
    class="{{ colors }} text-sm {{ textColor }}  disabled:bg-primary-200 whitespace-nowrap w-fit flex items-center {{ textStyle }} {{ padding }} rounded-lg {{ shadow ? 'shadow hover:shadow-lg' : '' }} outline-none focus:outline-none ease-linear transition-all duration-150"
    type="button"><i class="{{ icon }} {{ icon && btnText ? 'mr-2' : '' }} leading-relaxed"></i>
    {{btnText}}
</button>